export default {
  otherCategory: 'Inni ({count})',
};
